
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#192F52', // A professional, dark blue
    },
    secondary: {
      main: '#41B267', // A vibrant, yet professional green
    },
    background: {
      default: '#FFFFFF',
      paper: '#F9F9FF',
    },
    text: {
      primary: '#333333', // A dark gray for body text
      secondary: '#555555', // A lighter gray for secondary text
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    h1: {
      fontSize: '4rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
        fontSize: '2rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
    body1: {
      fontSize: '1.1rem',
      lineHeight: 1.6,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  spacing: 8, // Base spacing unit
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
  },
});

export default theme;
